<template>
  <div>
    <Table
      :key="initTable"
      ref="TableComponent"
      :body="{}"
      :title="'users_management'"
      :fields="tableFields"
      :url="url"
      :show-search="true"
      :show-dropdown="true"
      :dropdown-options="dropdownOptions"
      :action-button="button"
      @actionButtonTab="actionButtonTab"
    >
      <template #cell(id)="data">
        <p
          style="width:65px;"
          class="badge badge-light-primary"
        >
          U-{{ data.item.id }}
        </p>

      </template>
      <template #cell(created_at)="data">
        {{ data.item.created_at | formatDate }}
      </template>
      <template #cell(company_name)="data">
        <b-link
          v-if="
            data.item &&
              data.item.con_to_company &&
              data.item.con_to_company[0] &&
              data.item.con_to_company[0].company_id &&
              data.item.con_to_company[0].company &&
              data.item.con_to_company[0].company.name
          "
          :to="'/company/' + data.item.con_to_company[0].company_id"
        >
          {{ data.item.con_to_company[0].company.name }}
        </b-link>
        <span v-else>-</span>
      </template>
      <template #cell(type)="data">
        <span v-if="data && data.item && data.item.con_to_company[0].company && data.item.con_to_company[0].company.hasOwnProperty('role')">
          <span
            v-if="data.item.con_to_company[0].company.role == 'debtor'"
            class="d-flex"
          >
            <feather-icon
              icon="CodesandboxIcon"
              class="text-primary"
              height="21"
            />
            Debtor
          </span>
          <span
            v-else-if="data.item.con_to_company[0].company.role == 'seller'"
            class="d-flex"
          >
            <feather-icon
              icon="CodesandboxIcon"
              class="text-secondary"
              height="21"
            />
            Seller
          </span>
          <span
            v-else-if="data.item.con_to_company[0].company.role == 'buyer'"
            class="d-flex"
          >
            <feather-icon
              icon="CodesandboxIcon"
              class="text-secondary"
              height="21"
            />
            Buyer
          </span>
        </span>
      </template>
      <template #cell(custom)="data">

        <div style="display: flex;justify-content: center;align-items:center;">
          <b-button v-if="adminType(['super_admin','admin_type_a'])"
            v-b-tooltip.hover
            variant="outline-success"
            size="sm"
            class="button-space"
            :title="$t('login_as_client')"
            @click="loginAsClientFromAdmin(data.item)"
          >
            <feather-icon icon="UserIcon" />
          </b-button>
          <b-link v-if="adminType(['super_admin','admin_type_a'])" :to="'/user/' + data.item.id">
            <b-button
              v-b-tooltip.hover
              variant="outline-primary"
              size="sm"
              class="button-space"
              :title="$t('edit')"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </b-link>

          <b-button
            v-if="adminType(['super_admin'])"
            v-b-tooltip.hover
            v-b-modal.approveModal
            :title="data.item.status === 1 ? $t('deactivate-user') : $t('activate-user')"
            class="button-space"
            :variant="data.item.status === 1 ? 'outline-danger' : 'outline-success'"
            size="sm"
            @click="
            data.item.status === 1 ?
              changeModalInfo('delete', 'Deactivate', 'Are you sure that you want to deactivate this User?', data.item.id, data.item.status)
              :
              changeModalInfo('activate', 'Activate', 'Are you sure that you want to activate this User?', data.item.id, data.item.status)
            "
          >
            <feather-icon :icon="data.item.status === 1 ? 'SlashIcon' : 'CheckIcon'" />
          </b-button>
        </div>

      </template>
      <template #cell(status)="data">
        <span
          v-if="data.value == 2"
          class="text-danger"
        >{{ $t("deactivated") }}</span>
        <span
          v-else-if="data.value == 1 && data.item.con_to_company && data.item.con_to_company[0].company && data.item.con_to_company[0].company.status != 1 && data.item.email_verified_at != null"
          class="text-secondary"
        >{{ $t("waiting_for_company_review") }}</span>
        <span
          v-else-if="data.value == 1 && data.item.email_verified_at != null"
          class="text-success"
        >{{
          $t("active")
        }}</span>
        <span v-else-if="data.item.email_verified_at == null">{{ $t("incomplete") }}</span>
        <span v-else-if="data.value == 0">{{ $t("inactive") }}</span>

      </template>
    </Table>
    <ApproveModal
      :text-content="modalText"
      :title="modalTitle"
    />
  </div>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BPagination,
  BTr,
  BTh,
  BButton,
  BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import CustomLoader from '@/components/Common/CustomLoader'
import Table from '@/components/Common/Table2.vue'
import ApproveModal from '@/components/Common/ApproveModal'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'

export default {
  name: 'UsersList',
  components: {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BPagination,
    BTr,
    BTh,
    BButton,
    BLink,
    CustomLoader,
    Table,
    ApproveModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      button: {
        text: 'Export',
        link: '',
        color: 'primary',
      },
      dropdownOptions: [
        { value: '', text: this.$t('roles') },
        { value: 'buyer', text: this.$t('buyer') },
        { value: 'seller', text: this.$t('seller') },
      ],
      modalText: null,
      modalTitle: null,
      options: null,
      title: i18n.t('users_management'),
      items: [],
      user: null,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 12,
      status: [],
      isLoading: false,
      totalItems: 0,
      approveModalAction: null,
      url: '/user/admin/list',
      idToChange: '',
      currentStatus: null,
      initTable: 'init',
      searchQuery: '',
    }
  },
  computed: {
    rows() {
      return this.totalItems
    },
    tableFields() {
      const fields = [
        {
          label: 'created_at', align: 'start', key: 'created_at', sortable: true,
        },
        {
          label: 'id', align: 'start', key: 'id', sortable: true, value: 'id',
        },
        { label: 'type', align: 'start', key: 'type' },
        {
          label: 'full_name',
          align: 'start',
          key: 'full_name',
          sortable: true,
          value: 'full_name',
        },
        {
          label: 'email',
          align: 'start',
          key: 'email',
          sortable: true,
          value: 'email',
        },
        {
          label: 'company_name',
          key: 'company_name',
          sortable: false,
          company_id: 'company_id',
          customSlot: true,
          value: 'company_name',
        },
        {
          label: 'question',
          align: 'start',
          key: 'question',
          sortable: false,
          value: 'question',
        },
        {
          label: 'status',
          key: 'status',
          customSlot: true,
          sortable: false,
          value: 'status',
        },
      ];

      if (this.adminType(['super_admin', 'admin_type_a'])) {
        fields.push({
          text: '',
          customSlot: true,
          key: 'custom',
          class: 'text-right minWidth220',
          value: 'custom',
        });
      }

      return fields;
    }
  },
  created() {
    this.getApiData()
  },

  methods: {

    async actionButtonTab() {
      // this.exportLoading = true;

      try {
        let search = null
        let dropdown = null

        if (this.$refs.TableComponent) {
          if (this.$refs.TableComponent.$refs.filterField) {
            search = this.$refs.TableComponent.$refs.filterField.$el.value
          }

          if (this.$refs.TableComponent.$refs.selectedFilterField) {
            dropdown = this.$refs.TableComponent.$refs.selectedFilterField.$el.value
          }
        }

        const response = await this.$http.post('/user/admin/export',
          {
            search,
            dropdown,
          },
          { responseType: 'blob' })

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Users List.csv')
        document.body.appendChild(link)
        link.click()
        this.exportLoading = false
      } catch (error) {
        console.error('Error exporting data:', error)
        this.exportLoading = false
      }
    },

    callApproveModalAction() {
      this.changeUserStatus(this.idToChange, this.currentStatus)
    },
    changeModalInfo(action, title, text, id, currentStatus) {
      this.idToChange = id
      this.currentStatus = currentStatus
      if (action === 'delete') {
        this.modalText = text
        this.modalTitle = title
      } else {
        this.approveModalAction = action
        this.modalText = text
        this.modalTitle = title
      }
    },
    changeUserStatus(id, currentStatus) {
      this.$http.post(`user/admin/delete/${id}`,{toggleStatus: true}).then(res => {
        if (res) {
          this.initTable = Math.random()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: currentStatus === 1 ? 'User deactivated successfully' : 'User activated successfully',
              icon: 'SuccessIcon',
              variant: 'success',
            },
          })
        }
      })
      if (this.$route.path !== '/users') {
        router.push('/users')
      }
    },
    loginAsClientFromAdmin(item) {
      this.isLoading = true
      this.items = []
      this.$http
        .post('/loginFromAdmin', {
          email: item.email,
        })
        .then(response => {
          if (response.data.status === 200) {
            const stagingEndpoint = window.location.origin.includes('staging') || window.location.origin.includes('localhost') ? '-staging' : ''
            const token = response.data.value.token;
            const redirectUrl = `https://terminal${stagingEndpoint}.aequitex.com/loginFromAdmin/${token}?isAdminLogin=true`;

            // for checking in localhost
            // const redirectUrl = `http://localhost:8082/loginFromAdmin/${token}?isAdminLogin=true`;

            window.open(redirectUrl, '_blank');
          }
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    },
    getApiData() {
      this.isLoading = true
      this.items = []
      this.$http
        .post(`/user/admin/list?page=${this.page}`, {
          status: this.status,
          options: null,
          filters: this.filters,
          search: this.search,
        })
        .then(response => {
          if (response.data.status == 200) {
            this.items = response.data.value.data
            this.totalItems = response.data.value.total
            this.page = response.data.value.current_page
          }
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style scoped>
.button-space {
  margin-right: 5px;
}
</style>
